module.exports = __webpack_public_path__ + "static/media/042.c1f62401.jpg";